const promptConstructor = (template, values) => {
    let prompt = template;
    for(let property in values) {
        prompt = prompt.replace(`##${property}##`,values[property]);
    }
    return prompt
};

export default promptConstructor;